"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.purgeLocalStorage = void 0;
/**
 * Genesys cloud stores some data in local storage.
 * This function removes it to be able to auto login again.
 */
const purgeLocalStorage = () => {
  Object.keys(localStorage).filter(key => key.startsWith('_act') || key.includes(':gcm') || key.startsWith('_gca')).forEach(key => localStorage.removeItem(key));
};
exports.purgeLocalStorage = purgeLocalStorage;
